import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const bgClass = scrolled || !isHome
    ? 'bg-background-50 border-b border-background-200/70'
    : 'bg-transparent';

  const textClass = scrolled || !isHome
    ? 'text-foreground-900'
    : 'text-background-50';

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/core-philosophy', label: '核心理念' },
    { to: '/category/practice-methods', label: '实践方法' },
    { to: '/category/mind-training', label: '思维训练' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${bgClass}`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className={`font-heading text-xl font-bold whitespace-nowrap transition-colors duration-300 ${textClass}`}
          >
            {siteConfig.siteName}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 hover:opacity-70 ${
                  location.pathname === link.to
                    ? scrolled || !isHome ? 'text-primary-500' : 'text-background-50 font-bold'
                    : textClass
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            type="button"
            className={`md:hidden w-8 h-8 flex items-center justify-center ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}